// extracted by mini-css-extract-plugin
module.exports = {"main":"Ranking_main__Arxvx"};